import angular from 'angular';

import CaseModel from '../../models/case';

function caseEnable(CurrentCase) {
	return {
		restrict: 'A',
		link: function (scope, element) {
			CurrentCase.data.id ?
				element.removeClass('disabled') : element.addClass('disabled');
		}
	};
}
caseEnable.$inject = ['CurrentCase'];

export default angular.module('directives.case-enable', [CaseModel])
	.directive('caseEnable', caseEnable)
	.name;



// WEBPACK FOOTER //
// ./project/directives/case-enable/index.js